import { render, staticRenderFns } from "./VrpTabs.vue?vue&type=template&id=9b5a4906&scoped=true&"
import script from "./VrpTabs.vue?vue&type=script&lang=js&"
export * from "./VrpTabs.vue?vue&type=script&lang=js&"
import style0 from "./VrpTabs.vue?vue&type=style&index=0&id=9b5a4906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5a4906",
  null
  
)

export default component.exports